import React from 'react';


/**
 * Validation Message component to render error message
 * @param props 
 * @returns 
 */
const ValidationMessage: React.FunctionComponent<{
    message?: string,
    className?: string
}> = (props) => {
    return (
        <div className={props.className}>
            {props.message}
        </div>
    );
};

ValidationMessage.defaultProps = {
    // won't work on non-bootstrap component
    className: 'invalid-feedback'
}

export default ValidationMessage;